import {
  PreciselyAddress,
  PreciselyLocation,
} from "@covertree/new-business-graphql";
import { SelectOption } from "@covertree/ui/forms";

export type PreciselyAddressWithUnit = PreciselyAddress & {
  lotUnit?: string | null;
};

export function isDefined<T>(value: T | null | undefined): value is T {
  return !!value;
}

function equalOrBothFalsy(
  first?: string | null,
  second?: string | null
): boolean {
  return first === second || (!first && !second);
}

export const compareAddresses = (
  first: PreciselyAddressWithUnit | null | undefined,
  second: PreciselyAddressWithUnit | null | undefined
) => {
  return (
    !!first &&
    !!second &&
    first.city === second.city &&
    first.country === second.country &&
    first.state === second.state &&
    first.mainAddressLine === second.mainAddressLine &&
    first.addressLastLine === second.addressLastLine &&
    first.addressNumber === second.addressNumber &&
    first.postCode === second.postCode &&
    first.streetName === second.streetName &&
    equalOrBothFalsy(first.addressNumber, second.addressNumber) &&
    equalOrBothFalsy(first.lotUnit, second.lotUnit)
  );
};

export const areEqual = (
  option: SelectOption<PreciselyAddressWithUnit>,
  value: SelectOption<PreciselyAddressWithUnit>
) => {
  return compareAddresses(option.value, value.value);
};

export const preciselyLocationToOption = ({
  address,
  units,
}: PreciselyLocation): SelectOption<PreciselyAddressWithUnit>[] | undefined => {
  if (
    !address ||
    !address.formattedAddress ||
    !address.mainAddressLine ||
    !address.addressLastLine ||
    !address.city ||
    !address.state ||
    !address.country ||
    !address.postCode ||
    !address.streetName
  ) {
    return [];
  }

  let options: SelectOption<PreciselyAddressWithUnit>[] = [
    {
      label: address.formattedAddress,
      value: address,
    },
  ];

  if (units.length > 1) {
    options = units
      .map((unit) => ({
        label: unit.formattedUnitAddress,
        value: {
          ...address,
          formattedAddress: unit.formattedUnitAddress,
          lotUnit: unit.lotUnit ?? undefined,
        },
      }))
      .filter(isDefined);
  }

  return options;
};

export const locationsToOptions = (
  locations: PreciselyLocation[]
): SelectOption<PreciselyAddressWithUnit>[] => {
  return locations.flatMap(preciselyLocationToOption).filter(isDefined);
};

export const filterOptions = (opts: SelectOption<PreciselyAddressWithUnit>[]) =>
  opts;
